import styled from 'styled-components';

export const GroupLabel = styled.div`
  width: 100px;
`;

export const EmptySpaceFiller = styled.div`
  flex: 1;
`;
